import React, { useRef, useState, useEffect } from "react";

// import { ReactComponent as MenuIcon } from "../images/headericon/hamburgericon.svg";
import MenuIcon from "@mui/icons-material/Menu";
// import { ReactComponent as ThemeIcon } from "../images/headericon/themechangeicon.svg";
// import { ReactComponent as NotificationIcon } from "../images/headericon/notificationicon.svg";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import { ReactComponent as LogoutIcon } from "../images/headericon/logouticon.svg";
// import { ReactComponent as ProfileIcon } from "../images/headericon/profileicon.svg";
// import { ReactComponent as ChangePasswordIcon } from "../images/headericon/changepasswordicon.svg";
import {
  AppBar,
  Avatar,
  Badge,
  Button,
  ClickAwayListener,
  Divider,
  Grow,
  IconButton,
  MenuList,
  Paper,
  Popper,
  Toolbar,
  Typography
} from "@mui/material";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useStyles from "./styles";
import { Link } from "react-router-dom";
import axios from "axios";
import { decryptData } from "../../crypto";
import { useNavigate } from "react-router-dom";
// import { useTheme } from "@material-ui/core/styles";
import { useTheme } from "@mui/styles";
// import NotificationEmptyImage from "../images/headericon/notificationimg.jpg";
import allenLogo from '../../images/allenLogo.png'
// import digiLogo from '../../images/digiLogo.svg'

function Header(props) {
  const { toggleDarkMode, handleMenuCollapse } = props;

  const navigate = useNavigate();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [instituteName, setInstitutename] = useState("");
  const [openNotification, setOpenNotification] = useState(false);

  const anchorNotificationRef = useRef(null);

  const clientLogo = sessionStorage.getItem('client_logo')
  const clientName = sessionStorage.getItem('client_name')

  const theme = useTheme();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (
      event &&
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };
  const handleLogout = (event) => {
    handleClose({ target: document.body });
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    // Clear sessionStorage
    sessionStorage.clear();
    // Navigate to home URL
    window.location.href = "/";
    // setOpen(false);
  };

  const handleNotificationPopup = () => {
    setOpenNotification((prevOpen) => !prevOpen);
  };
  const handleNotificationClose = (event) => {
    if (
      event &&
      anchorNotificationRef.current &&
      anchorNotificationRef.current.contains(event.target)
    ) {
      return;
    }
    setOpenNotification(false);
  };

  const getInitials = (name) => {
    return name && name.trim() ? name.charAt(0).toUpperCase() : "A";
  };

  return (
    <AppBar
      className={`${classes.headermain} ${classes.dflex} ${classes.w100} ${classes.h62px} ${classes.bgblue} ${classes.boxshadow0} ${classes.justifycenter}`}
      position="static"
    >
      <Toolbar className={`${classes.justifyspacebetween} ${classes.p0} ${classes.w80}`}
      style={{margin:'auto'}}
      >
        <IconButton
          edge="start"
          className={`${classes.ml1} ${classes.mr1}`}
          color="inherit"
          aria-label="menu"
          // onClick={handleMenuCollapse}
        >
          {/* <MenuIcon /> */}
         <img src={clientLogo} alt="logo" width={100} height={40} />
         {/* <img src={digiLogo} alt="logo" height={55} /> */}
        </IconButton>
        <Typography
        style={{
          fontWeight:'bold',
          fontSize:'20px'
          
        }}
        > {clientName}</Typography>
        <div
          className={`${classes.dflex} ${classes.bgdarkblue} ${classes.bgdarkblue}  ${classes.py5px}  ${classes.pr4} ${classes.pl2} ${classes.alignitemscenter}`}
        >
          <div className={`${classes.dflex} ${classes.alignitemscenter}`}>
            {/* <Button
              className={`${classes.mr1} ${classes.bgtransparent} ${classes.bghoverwhite} ${classes.boxshadow0} ${classes.w27px} ${classes.p0_5} ${classes.fillhoverblue}`}
              variant="contained"
              color="primary"
              onClick={toggleDarkMode}
            >
              <ThemeIcon />
            </Button> */}
            {/* <Button
             onClick={handleNotificationPopup}
             ref={anchorNotificationRef}
            aria-controls={openNotification ? "menu-list-grow" : undefined}
            aria-haspopup="true"
              className={`${classes.mr1} ${classes.bgtransparent} ${classes.bghoverwhite} ${classes.boxshadow0} ${classes.w27px} ${classes.p0_5} ${classes.fillhoverblue}`}
              variant="contained"
            > */}
            {/* <NotificationsIcon /> <span>Ritesh - 9109910500</span> */}
            {/* </Button> */}
            <Popper
              open={openNotification}
              anchorEl={anchorNotificationRef.current}
              role={undefined}
              transition
              className={`${classes.notificationdropdowncard} `}
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleNotificationClose}>
                      <div>
                        no data
                        {/* <img src={NotificationEmptyImage} alt="preview" width="100%" /> */}
                      </div>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
          {/* <Button
            className={`${classes.cursorpointer}`}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <Avatar
              style={{
                width: theme.spacing(4.5),
                height: theme.spacing(4.5),
                fontSize: "1.5rem",
                backgroundColor: "lightyellow",
                color: "purple",
                fontFamily: '"Roboto", sans-serif',
              }}
            >
              {getInitials(clientName)}
            </Avatar>
            <ExpandMoreIcon className={classes.textcolorwhite} />
          </Button> */}

          <IconButton
            edge="start"
            className={`${classes.ml1} ${classes.mr1}`}
            color="inherit"
            aria-label="menu"
            onClick={handleLogout}
          >
            <PowerSettingsNewIcon />
          </IconButton>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            className={`${classes.dropdowncard} `}
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <Link to="" className={classes.dropdownlink}>
                        <Link
                          to="/admin/settings"
                          className={classes.menuButton}
                        >
                          <Button
                            fullWidth
                            onClick={handleClose}
                            className={` ${classes.justifyleft}`}
                          >
                            <span
                              className={`${classes.headname} ${classes.dflex} ${classes.alignitemscenter}`}
                            >
                              {/* <ProfileIcon className={`${classes.mr0_5}`} />  */}
                              My Profile
                            </span>
                          </Button>
                        </Link>
                        <Link
                          to="/admin/changepassword"
                          className={classes.menuButton}
                        >
                          <Button
                            fullWidth
                            onClick={handleClose}
                            className={` ${classes.justifyleft}`}
                          >
                            <span
                              className={`${classes.headname} ${classes.dflex} ${classes.alignitemscenter}`}
                            >
                              {/* <ChangePasswordIcon
                                className={`${classes.mr0_5}`}
                              />{" "} */}
                              Change Password
                            </span>
                          </Button>
                        </Link>
                        <Button
                          fullWidth
                          onClick={handleLogout}
                          className={`${classes.menuButton} ${classes.justifyleft}`}
                        >
                          <span
                            className={`${classes.headname} ${classes.dflex} ${classes.alignitemscenter}`}
                          >
                            {/* <LogoutIcon className={`${classes.mr0_5}`} />  */}
                            Logout
                          </span>
                        </Button>

                        <Divider />
                      </Link>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Toolbar>
    </AppBar>
  );
}
export default Header;
